"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Kind = void 0;
var Kind;
(function (Kind) {
    /** A link that is blue on light backgrounds or white on dark backgrounds, with a rightward caret. */
    Kind["utilityPrimary"] = "link-utility-primary";
    /** A link that is dark gray on light backgrounds or white on dark backgrounds, with a rightward caret. */
    Kind["utilitySecondary"] = "link-utility-secondary";
    /** A small link with a rightward arrow. */
    Kind["tertiarySmall"] = "link-tertiary-small";
    /** A large link with a rightward arrow. */
    Kind["tertiaryLarge"] = "link-tertiary-large";
    /** A text link with an underline. */
    Kind["textUnderline"] = "link-text";
    /** A text link with medium font. */
    Kind["textMedium"] = "link-text2";
    /** A text link without any distinguishing features. Use this very sparingly. As in almost never. */
    Kind["textPlain"] = "link-text3";
    /** A link with Icon prepended before text. */
    Kind["withPrependIcon"] = "link-icon-left";
    /** A link with Icon appended after text. */
    Kind["withAppendIcon"] = "link-icon-right";
    /** A link no default classes */
    Kind["none"] = "";
})(Kind = exports.Kind || (exports.Kind = {}));



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/Link/LinkProps.js
// module id = 1653
// module chunks = 8